import { useState } from 'react'
import ConfirmModal from 'ui/components/ConfirmModal/'
import ControlButton from 'ui/components/ControlButton'
import Select from 'ui/components/forms/Select/'
import { notifyError } from 'ui/components/Notify'
import { DeleteButtonWrap, SelectCol, SelectRow, SelectWrapper } from './styled'

export function SelectUser({
  users,
  userList,
  roleList,
  hasEstimate,
  updateProjectUserMutation,
  deleteProjectUserMutation,
  slug,
  priceList,
  canEditProjectUsers,
}) {
  const [openModal, setModalOpen] = useState(false)
  const [currentUser, setCurrentUser] = useState({})

  const deleteHandler = async () => {
    try {
      await deleteProjectUserMutation({
        slug,
        userId: currentUser?.id,
        roleId: currentUser?.role[0].id,
      }).unwrap()
    } catch (error) {
      notifyError(error?.data?.message)
    } finally {
      setModalOpen(false)
      setCurrentUser(null)
    }
  }

  const setUserToDelete = (user) => {
    setCurrentUser(user)
    setModalOpen(true)
  }

  const getRoleDefaultValue = (role) => {
    const roleItem = role?.find(Boolean)

    if (!roleItem?.id) {
      return null
    }

    const label = roleItem.label || roleItem.name || ''

    return {
      id: roleItem.id,
      value: label,
      label,
    }
  }

  const roleChange = (value, user, priceValue = null) => {
    const currentRole = roleList.find((role) => value.id === role.id)

    if (currentRole) {
      updateProjectUserMutation({
        slug,
        userId: user.id,
        roleId: currentRole.id,
        priceId: priceValue ? priceValue.id : null,
      })
    } else {
      notifyError('Не обнаружена роль')
    }
  }

  const getPriceRoleValue = (user, priceList) =>
    priceList.find((item) => item.id === user.pricelist_role_id) || null

  return (
    <>
      {users?.map((user, index) => {
        return (
          <SelectRow key={user.id}>
            <SelectCol>
              <SelectWrapper>
                <Select
                  label="Имя"
                  id={`nameSelect${index}`}
                  options={userList}
                  placeholder="Имя"
                  maxHeight="200px"
                  defaultValue={{
                    ...user,
                    label: `${user.name ? `${user.surname} ${user.name}` : ''}`,
                  }}
                  isDisabled={true}
                />
              </SelectWrapper>
            </SelectCol>
            <SelectCol>
              <Select
                placeholder="Роль"
                label="Роль"
                id={`roleSelect${index}`}
                required
                options={roleList}
                onChange={(value) => roleChange(value, user)}
                defaultValue={getRoleDefaultValue(user.role)}
                maxHeight="250px"
                isDisabled={!canEditProjectUsers}
              />
            </SelectCol>
            <SelectCol>
              <Select
                placeholder="Роль из сметы"
                label="Роль из сметы"
                id={`priceSelect${index}`}
                required={hasEstimate}
                options={priceList}
                onChange={(value) => roleChange(...user.role, user, value)}
                value={getPriceRoleValue(user, priceList)}
                maxHeight="250px"
                isDisabled={!canEditProjectUsers}
              />
            </SelectCol>
            {canEditProjectUsers && (
              <DeleteButtonWrap>
                <ControlButton
                  theme="edit"
                  onClick={() => setUserToDelete(user)}
                >
                  Удалить
                </ControlButton>
              </DeleteButtonWrap>
            )}
          </SelectRow>
        )
      })}
      <ConfirmModal
        title={`Удалить пользователя ${currentUser?.name + ' ' + currentUser?.surname} из проекта?`}
        open={openModal}
        handlerClose={() => setModalOpen(false)}
        confirmHandler={deleteHandler}
      />
    </>
  )
}
